/**
 * VerifyOTP Page - Now uses UnifiedOTP component
 * Handles OTP verification for existing users
 */
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import UnifiedOTP from '../components/UnifiedOTP';

const VerifyOTP = () => {
  const navigate = useNavigate();
  const identifier = useSelector((state) => state.auth.user?.email || state.auth.user?.phone);

  const handleSuccess = (result) => {
    // Check if patient needs onboarding
    if (result.user?.role === 'patient' && !result.user?.patient_profile_completed) {
      navigate('/onboarding/patient/');
    } else {
      navigate(`/${result.user?.role}-dashboard`);
    }
  };

  const handleError = (error) => {
    console.error('OTP verification error:', error);
    // Error handling is done in UnifiedOTP component
  };

  return (
    <UnifiedOTP
      mode="verify"
      identifier={identifier}
      onSuccess={handleSuccess}
      onError={handleError}
      title="Almost There! 🚀"
      subtitle="We've sent a 6-digit code to verify your account"
    />
  );
};

export default VerifyOTP;